import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import { fetchStatusConfig, initialState } from '../services/fetchStatusConfig'

export { useStatusConfig }

const queryKey = 'statusconfig'

const useStatusConfig = () => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data } = useQuery({
    queryFn: fetchStatusConfig,
    queryKey: [queryKey],
    enabled: hasPermissions,
  })

  return {
    data: data || initialState.data,
  }
}
